import { useState } from "react";
import { Award, Globe2, Handshake, Users } from "lucide-react";
import CountUp from "react-countup";
import { stats } from "../../data/homeData";

const statIcons = [Globe2, Award, Users, Handshake];

function StatCard({ stat, Icon }) {
  const [glow, setGlow] = useState(false);

  return (
    <div className={`relative flex flex-col items-center text-center p-6 rounded-2xl transition-all duration-700 ${glow ? 'counter-glow-active' : ''}`}>
      <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-soft-white/10 text-soft-white shadow-[inset_0_1px_rgba(255,255,255,0.1)] border border-white/5 mb-4">
        <Icon className="h-6 w-6 text-warm-gold" aria-hidden="true" />
      </span>
      <p className="text-3xl font-bold text-soft-white sm:text-4xl md:text-5xl tracking-tight">
        {stat.prefix}
        <CountUp
          end={stat.value}
          duration={2.1}
          enableScrollSpy
          scrollSpyDelay={100}
          scrollSpyOnce
          separator=","
          onEnd={() => setGlow(true)}
        />
        {stat.suffix}
      </p>
      <p className="mt-2 text-sm font-semibold uppercase tracking-wider text-sky-glow/70">{stat.label}</p>
    </div>
  );
}

function StatsSection() {
  return (
    <section id="trust" className="py-20 md:py-28 bg-midnight-navy border-y border-white/5 relative overflow-hidden">
      <div className="absolute left-1/2 top-0 -ml-[400px] h-px w-[800px] bg-gradient-to-r from-transparent via-royal-blue/50 to-transparent" />
      <div className="absolute right-0 bottom-0 h-64 w-64 rounded-full bg-warm-gold/10 blur-[120px]" />
      <div className="absolute left-0 top-0 h-40 w-40 rounded-full bg-royal-blue/20 blur-[100px]" />
      
      <div className="relative mx-auto w-full max-w-7xl px-6">
        <div className="mx-auto max-w-3xl text-center mb-16">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-warm-gold bg-warm-gold/10 inline-flex px-3 py-1 rounded-full">
            Trusted by Ambitious Students
          </p>
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-soft-white sm:text-3xl md:text-5xl leading-tight">
            Credibility Backed by Proven Results
          </h2>
        </div>

        <div className="grid gap-4 sm:gap-8 md:grid-cols-2 lg:grid-cols-4 lg:divide-x divide-white/10">
          {stats.map((stat, index) => {
            const Icon = statIcons[index % statIcons.length];
            return <StatCard key={stat.label} stat={stat} Icon={Icon} />;
          })}
        </div>
      </div>
    </section>
  );
}

export default StatsSection;
